import axios from 'axios';

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_SERVER_URL,
  timeout: 50000,
  headers: {
    'Content-Type': 'application/json',
  },
});

axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

export function configureAxios(navigate) {
  axiosInstance.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error.response) {
        const { status } = error.response;
        console.error('status2:', status);
        switch (status) {
          case 401:
            localStorage.removeItem('token');
            window.location.href = '/login';
            alert('다시 로그인 해주세요.');
            return;
          case 403:
            // 권한 없음(인증은 유효) → 강제 로그아웃/로그인 리다이렉트 하지 않음
            alert('접근 권한이 없습니다.');
            return Promise.reject(error);
          case 500:
            navigate('/server-error', { replace: true });
            return;
          default:
            console.error('처리되지 않은 에러:', error.response);
        }
        console.error('status: end');
      } else if (error.request) {
        navigate('/network-error', { replace: true });
        return;
      } else {
        console.error('에러 발생:', error.message);
      }
      return Promise.reject(error);
    }
  );
  return axiosInstance;
}

export default axiosInstance;